import React from 'react'
import Header from '../../common/Header'
import BlogSingleSection from './components/BlogSingleSection'
import Footer from '../../common/Footer'

const BlogSingle = () => {
  return (
    <div>
      <Header preclass="modified" modifiedHeader={true} />
      <BlogSingleSection/>
      <Footer/>
    </div>
  )
}

export default BlogSingle
